import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { EyeIcon, EyeSlashIcon, CheckIcon } from "@heroicons/react/24/solid";
import { GoogleIcon } from "src/components/common/Icons/GoogleIcon";
import { Apple, Circle, EmailOutlined } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import {
  ActionIcon,
  Button,
  Card,
  Center,
  Divider,
  Grid,
  Image,
  List,
  Space,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { authService } from "src/services/services/auth/auth.api";
import { ResponseKind } from "src/services/services/MainService";
import { COLORS, FONT_SIZES } from "src/utils/styles";
import { AppButton } from "src/components/common/Buttons/AppButton";
import Icon from "src/components/common/Icons/Icons/Icon";
import { IconButton } from "src/components/common/Buttons/IconButton";
import { FocusButton } from "src/components/common/Buttons/FocusButton";
import useResponsive from "src/hooks/useResponsive";
import { useMediaQuery } from "@mantine/hooks";
import theme from "@material-tailwind/react/theme";
import { colors } from "@mui/material";
import { userRoutes } from "src/navigators/routes/user";
import { useAppDispatch, useAppSelector } from "src/redux/redux-store/hooks";
import { handleUserUpdate } from "src/redux/redux-store";
import { paymentService } from "src/services/services/payment/payment.api";

const PaymentFeedback: FunctionComponent = () => {
  const [verificationMessage, setVerificationMessage] = useState("");
  const url = window?.location?.href;
  const dispatch = useAppDispatch()
  const user = useAppSelector(state => state.user)
  const navigation = useNavigate();
  const isMobile = useMediaQuery("(max-width: 500px)");
  const [paymentUrl, setPaymentUrl] = useState("");

  const navigateToHome = () => {
    navigation(userRoutes.DASHBOARD, {replace: true})
  }

  useEffect(() => {
    dispatch(handleUserUpdate())
  }, [])

  const goToCustomerPortal = async () => {
      if (user.paid) {
        const response = await paymentService.createPortalSession();
  
        if (response.kind == ResponseKind.OK && response.data) {
          setPaymentUrl(response.data);
        }
        return;
      }
  }

  const handleButtonClick = async () => {
    goToCustomerPortal();
    if (paymentUrl) {
      window.location.href = paymentUrl;
    }
  };

  return (
    <div className="w-full h-full">
      <div className="h-10 flex flex-row space-x-2 pl-4 pt-4 items-center">
        <ActionIcon onClick={navigateToHome} ><Icon size="1rem" name="back"/></ActionIcon>
        <Text size={"sm"}>Dashboard</Text>
      </div>
      <div className="h-full grid lg:grid-cols-3">
        <Card
          style={{
            borderWidth: 1,
            borderRadius: 0,
            borderColor: colors.grey[600],
          }}
          className="flex lg:col-span-1"
        >
          <div
            className={`flex flex-1 self-center items-center justify-center`}
          >
            <Card
              className={`shrink-0 ${
                isMobile ? "w-[100%]" : "w[80%]"
              } h-[50%] flex-col rounded-2xl p-10`}
            >
              <Image
                radius={4}
                height={isMobile ? "6rem" : "12rem"}
                width={isMobile ? "6rem" : "12rem"}
                src={"/appIcon.jpeg"}
              />
              <Space h={20} />
              <Text fw={600} size={"lg"}>
                Caira Premium
              </Text>
              <Space h={20} />
              <FocusButton
                w={isMobile ? "100%" : "60%"}
                text="Visit Customer Portal"
                icon="copy"
                onClick={handleButtonClick}
              />
              <Space h={20} />
            </Card>
          </div>
        </Card>

        <Card
          style={{ borderRadius: 0 }}
          className="flex lg:col-span-2 items-center justify-center"
        >
          <div className="flex p-4 flex-col item-center place-items-center justify-center space-y-4 bg-green-100 rounded-2xl">
            <ThemeIcon radius={40} p={"md"} color="green">
              <Icon size="1.5rem" name="success" />{" "}
            </ThemeIcon>
            <Text style={{ color: colors.green[600] }} size={"sm"}>
              Your payment has been successfully made
            </Text>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PaymentFeedback;
